var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _circle, _circle2, _path, _path2, _path3, _circle3, _circle4, _path4, _path5, _path6, _path7, _path8, _circle5, _circle6, _path9, _circle7, _circle8, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMolecule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.071,
    x2: 135.922,
    y1: 119.033,
    y2: 208.883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.351,
    x2: 37.547,
    y1: 156.79,
    y2: 96.106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.437,
    x2: 169.795,
    xlinkHref: "#lg1",
    y1: 171.577,
    y2: -5.775
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.273,
    x2: 118.168,
    xlinkHref: "#lg1",
    y1: 203.005,
    y2: 182.593
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.479,
    x2: 134.646,
    xlinkHref: "#lg2",
    y1: 170.5,
    y2: 188.301
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.752,
    x2: 404.373,
    y1: 174.592,
    y2: 344.213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.466,
    x2: 218.66,
    y1: 245.87,
    y2: 131.31
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.302,
    x2: 468.319,
    xlinkHref: "#lg3",
    y1: 273.786,
    y2: -61.022
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.874,
    x2: 348.009,
    xlinkHref: "#lg3",
    y1: 210.626,
    y2: 131.762
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.113,
    x2: 329.984,
    xlinkHref: "#lg3",
    y1: 350.429,
    y2: 320.522
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.948 .318 -.318 -.948 179.275 -2564.406)",
    gradientUnits: "userSpaceOnUse",
    x1: 768.167,
    x2: 807.49,
    xlinkHref: "#lg2",
    y1: -2808.985,
    y2: -2808.985
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -878.461 -655.732)",
    gradientUnits: "userSpaceOnUse",
    x1: 1423.924,
    x2: 1463.247,
    xlinkHref: "#lg2",
    y1: -353.397,
    y2: -353.397
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.016,
    x2: 501.866,
    y1: 43.417,
    y2: 133.268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.296,
    x2: 403.492,
    y1: 81.174,
    y2: 20.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.382,
    x2: 535.739,
    y1: 95.961,
    y2: -81.391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -677 -280.331)",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.464,
    x2: 1260.314,
    y1: 378.762,
    y2: 468.612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -677 -280.331)",
    gradientUnits: "userSpaceOnUse",
    x1: 1204.744,
    x2: 1161.94,
    y1: 416.519,
    y2: 355.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.961 .278 -.278 .961 -677 -280.331)",
    gradientUnits: "userSpaceOnUse",
    x1: 1198.83,
    x2: 1294.188,
    y1: 431.306,
    y2: 253.955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.028,
    cy: 144.99,
    fill: "url(#SVGID_1_)",
    r: 69.374
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.028,
    cy: 144.99,
    fill: "url(#SVGID_2_)",
    r: 57.898
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m103.061 82.932c4.679 9.338 7.316 19.877 7.316 31.033 0 38.314-31.06 69.374-69.374 69.374-11.156 0-21.695-2.637-31.033-7.316 11.39 22.733 34.9 38.341 62.058 38.341 38.314 0 69.374-31.059 69.374-69.374 0-27.158-15.608-50.668-38.341-62.058z",
    fill: "url(#SVGID_3_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m129.509 183.839-26.364-8.699 18.409 18.409c2.931-2.988 5.601-6.232 7.955-9.71z",
    fill: "url(#SVGID_4_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m96.269 151.834c4.02-10.087 15.456-15.006 25.543-10.986l56.078 22.347c10.087 4.02 15.006 15.456 10.986 25.543-4.02 10.087-15.456 15.006-25.543 10.986l-56.078-22.347c-10.087-4.019-15.006-15.455-10.986-25.543z",
    fill: "url(#SVGID_5_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.753,
    cy: 223.593,
    fill: "url(#SVGID_6_)",
    r: 130.965
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.753,
    cy: 223.593,
    fill: "url(#SVGID_7_)",
    r: 109.302
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m342.338 106.44c8.833 17.629 13.812 37.524 13.812 58.585 0 72.33-58.635 130.965-130.965 130.965-21.061 0-40.956-4.979-58.585-13.812 21.503 42.916 65.884 72.38 117.153 72.38 72.33 0 130.965-58.635 130.965-130.964 0-51.27-29.465-95.651-72.38-117.154z",
    fill: "url(#SVGID_8_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m414.655 227.519c.038-1.304.064-2.612.064-3.926 0-35.899-14.449-68.421-37.843-92.078l-29.635 28.59z",
    fill: "url(#SVGID_9_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m331.094 308.724 8.982 33.133c5.36-2.557 10.517-5.472 15.444-8.706z",
    fill: "url(#SVGID_10_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m309.254 302.061c10.296-3.451 21.44 2.097 24.891 12.393l19.187 57.237c3.451 10.296-2.097 21.44-12.393 24.891-10.296 3.451-21.44-2.097-24.891-12.393l-19.187-57.237c-3.451-10.296 2.097-21.44 12.393-24.891z",
    fill: "url(#SVGID_11_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m347.241 160.105c-7.678-7.678-7.678-20.127 0-27.806l62.109-62.109c7.678-7.678 20.127-7.678 27.806 0 7.678 7.678 7.678 20.127 0 27.806l-62.109 62.109c-7.679 7.679-20.128 7.679-27.806 0z",
    fill: "url(#SVGID_12_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.972,
    cy: 69.374,
    fill: "url(#SVGID_13_)",
    r: 69.374
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.972,
    cy: 69.374,
    fill: "url(#SVGID_14_)",
    r: 57.899
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m469.005 7.316c4.679 9.338 7.316 19.877 7.316 31.033 0 38.314-31.06 69.374-69.374 69.374-11.156 0-21.695-2.637-31.033-7.316 11.39 22.733 34.899 38.341 62.058 38.341 38.314 0 69.374-31.06 69.374-69.374 0-27.158-15.608-50.667-38.341-62.058z",
    fill: "url(#SVGID_15_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.051,
    cy: 440.608,
    fill: "url(#SVGID_16_)",
    r: 69.374
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.051,
    cy: 440.608,
    fill: "url(#SVGID_17_)",
    r: 57.898
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m407.09 389.603c1.903 10.27 1.512 21.127-1.585 31.844-10.635 36.809-49.095 58.027-85.904 47.392-10.718-3.097-20.11-8.556-27.783-15.643 4.633 25.001 22.886 46.521 48.977 54.06 36.809 10.635 75.269-10.583 85.904-47.392 7.538-26.091-.931-53.008-19.609-70.261z",
    fill: "url(#SVGID_18_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMolecule);
export default __webpack_public_path__ + "static/media/icon-molecule.db13b460b96f6c3aff17f9dfdf299077.svg";
export { ForwardRef as ReactComponent };